import 'motivate-framework/dist/css/theme-dark.css'
import Vue from 'vue'
import App from './App.vue'
import router from './router/index'
import store from './store'
import './registerServiceWorker'
import Apiclient from 'api-wrapper/dist';
import {Portlet, isAuthenticated} from 'motivate-framework-components'
import axios from "axios";
import LogRocket from 'logrocket'
Vue.component('portlet', Portlet)
Vue.component('isAuthenticated', isAuthenticated)

Vue.config.performance = true
window._ = require('lodash');
window.moment = require('moment')
require('./filters/filters')
require('./plugins/toaster')

var urlParams = getParameters(window.location.hash.substr(1))
var token;
if (urlParams.access_token) {
    token = urlParams.access_token
} else {
    token =   store.state.oAuthToken
}
store.commit('setOauthToken', token)

var perfectCoatDataApi = process.env.VUE_APP_PERFECT_COAT_API
var acApi = process.env.VUE_APP_ACCES_CONTROL_API

let portalApi = axios.create({
    baseURL: perfectCoatDataApi,
    timeout: 5000,
    headers: {
        Authorization: 'Bearer ' + token
    }
});

window.PORTAL_API = portalApi;

var options = {
    REDIRECT_URI: process.env.VUE_APP_REDIRECT_URI,
    CLIENT_ID: process.env.VUE_APP_CLIENT_ID,
    baseURL: acApi,
    version: 'v1',
    token: token
}
var APICLIENT = Apiclient(options)

Vue.prototype.$ApiClient = APICLIENT
 APICLIENT.silentRefresher(store, [Vue.prototype.$ApiClient.axiosWrapper, window.PORTAL_API])
 APICLIENT.User.getMe().then((res) => {


    if (res.status == 200) {
        LogRocket.init('motivate/perfect-coat-portal');
        LogRocket.identify(res.data.id, {
            name: res.data.name,
            email: res.data.email,

            // Add your own custom user variables here, ie:
            companyID: res.data.company.id,
            company: res.data.company.name
        });

        store.commit('users/setMe', res.data)
        store.dispatch('getMyProfile', APICLIENT).then((res) => {
            // store.commit('setOauthToken', token)
            new Vue({
                router: router,
                store: store,
                render: h => h(App),

            }).$mount('#app')
        })
    }
})

function getParameters(url) {
    //Params obj
    var params = {};
    //To lowercase
    // url = url.toLowerCase();
    //To array
    url = url.split('&');

    //Iterate over url parameters array
    var length = url.length;
    for (var i = 0; i < length; i++) {
        //Create prop
        var prop = url[i].slice(0, url[i].search('='));
        //Create Val
        var value = url[i].slice(url[i].search('=')).replace('=', '');
        //Params New Attr
        params[prop] = value;
    }

    return params;
}